import React, { useState } from 'react';
import { findIngredientDataNames, formatDisplayName } from 'helpers/ingredientHelpers';
import { ingredientsCreateState } from 'store/storeValtio';
import * as mh from 'helpers/medicationHelpers';
import ConfirmModal from '../../common/ConfirmModal';

export default function IngredientName({med,next}) {
  console.log('IngredientName', med);
  
  const [name,setName] = useState('');
  const [ingredientNames, setIngredientNames] = useState([]);
  const [popup, setPopup] = useState({
    show: false,
    name: '',
    type: 'X',
    class: 'X',
    id: 0,
  });

  function nameChange(e) {
    //console.log('nameChange', e.target.value);
    const txt = e.target.value;
    const tu = txt.toUpperCase();
    setName(tu);
    const names = findIngredientDataNames(txt);
    //console.log('nameChange', names, tu);
  
    // if the name is not already in the list, add it
    const isIn = tu.length === 0 || names.some(n => n.displayName === tu);
    if (!isIn) {
      //console.log('not included', names, tu);
      const nl = {
        name: tu,
        altName: '',
        displayName: tu,
        class: '',
        type: '',
        source: '',
        id: 0,
      }
      names.unshift(nl);
    }
    console.log('names',names)
    setIngredientNames(names);
  }

  function confirmName(n) {
    console.log('confirmName', n);
    setPopup({ show: true, name: n.name, type: 'X', id: 0 });
  };

  function selectIngredient(n) {
    console.log('selectIngredient', n);
    setName(n.name);
    if (n.type === 'X') {
      const cn = confirmName(n)
      console.log('confirm', cn);
      return;
      }

    doSelect(n);
  }

  function doSelect(n) {
    ingredientsCreateState.medicationId = med.medicationId;
    ingredientsCreateState.DsldId = Number(n.DsldId);
    console.log('doSelect', n, ingredientsCreateState);

    next(2);
  }

  function confirm(tf) {
    console.log('confirm', tf);
    if (tf) {
      doSelect(popup)
    }
    setPopup({ show: false });
  }

  const li = 'mcard w-[75%] border-2 border-gray-500 px-2 mx-1';
  return (
    <>
      <div className='medBody'>
          What is the <b>name</b> of your Ingredient?
      </div>
      <ConfirmModal
          open={popup.show} 
          onConfirm={()=>confirm(true)}
          onCancel={()=>confirm(false)}
          title={'Use this Ingredient name?'}
          content={popup.name}
          confirmButton='Use Name'
          />

      <div className='medName'>
        <input 
          autoFocus 
          value={name} 
          onChange={(e)=>nameChange(e)} 
          className='ingredientInput' 
          id='ingredient_name' 
          name='ingredient_name' 
          type='text' 
          autoComplete='off' 
          required /> 
      </div>
      <div className='ingredientList'>
        {/* <ul className='itemList'> */}
          {ingredientNames.map((n,ix) => {
            //console.log('in', n);
            const dn = formatDisplayName(n);
            return (
              <div
                key={ix} 
                className="medCard" 
                onClick={()=>selectIngredient(n)} 
                >
                {dn}
              </div>
              )
            })
          }
        {/* </ul> */}
      </div>
    </>
  );
}
